import {
  BANNER_LIST_REQUEST,
  BANNER_LIST_SUCCESS,
  BANNER_LIST_FAIL,
} from "../Constants/BannerConstants";

const initialState = {
  loading: false,
  banners: [],
  fetchedAt: null,
};

export const bannerStoreListReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANNER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case BANNER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        banners: action.payload,
        fetchedAt: Date.now(),
      };

    case BANNER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};